import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';
import { DocumentSearch24Regular } from '@fluentui/react-icons';

interface EmptyStateProps {
  icon?: React.ReactElement;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--space-2xl) var(--space-lg)',
    textAlign: 'center',
  },
  iconWrap: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-background)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 'var(--space-md)',
    color: 'var(--color-text-tertiary)',
  },
  title: {
    fontSize: '15px',
    fontWeight: '500',
    color: 'var(--color-text)',
    marginBottom: 'var(--space-xs)',
  },
  description: {
    fontSize: '13px',
    color: 'var(--color-text-secondary)',
    maxWidth: '320px',
  },
  action: {
    marginTop: 'var(--space-md)',
  },
});

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  const s = useStyles();

  return (
    <div className={s.root}>
      <div className={s.iconWrap}>
        {icon || <DocumentSearch24Regular style={{ fontSize: '24px' }} />}
      </div>
      <Text className={s.title}>{title}</Text>
      {description && <Text className={s.description}>{description}</Text>}
      {action && <div className={s.action}>{action}</div>}
    </div>
  );
}
